import { render, staticRenderFns } from "./DepartureTabsBooking.vue?vue&type=template&id=6b23ee38&scoped=true&"
import script from "./DepartureTabsBooking.vue?vue&type=script&lang=js&"
export * from "./DepartureTabsBooking.vue?vue&type=script&lang=js&"
import style0 from "./DepartureTabsBooking.vue?vue&type=style&index=0&id=6b23ee38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b23ee38",
  null
  
)

export default component.exports